import React, { useMemo, useState } from 'react';
import { Stack, Typography, Box, Avatar, Menu } from '@mui/material';
import images from 'src/config/images';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout, showWelcomeModal } from 'src/modules/auth/actions/authActions';
import { makeStyles } from '@mui/styles';
import AppMenu from '../../../../components/App/AppMenu';
import UpgradeSubscriptionModal from '../../../../components/App/Sidebar/UpgradeSubscriptionModal';

const trialSubscriptionPlansPriceId = [
  'Starter-Monthly-Plan-GBP-Monthly',
  'Trial-plan-7-day-GBP-Weekly',
];

const useStyles = makeStyles(({ palette }) => ({
  iconStyle: {
    padding: '12px 0',
    display: 'grid',
    justifyContent: 'center',
    gap: '12px',
    width: '100px',
    height: '94px',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#21313f',
    },
  },
  menuPaper: {
    '& .MuiListItemIcon-root': {
      minWidth: '40px',
    },
    color: palette.text.white,
    backgroundColor: '#21313f',
    borderRadius: '16px',
    marginTop: '10px',
    marginLeft: '-13px',
  },
  goToProfile: {
    paddingLeft: '0px',
    color: '#e4c077',
  },
}));

const LandingPageView = ({ userData, newUser = false, ...props }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [userNameMenuElement, setUserNameMenuElement] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const name = userData ? `${userData.fname || ''}` : '';
  const userNameId = 'user-name-menu-id';

  const hasLmsAccess = useMemo(() => {
    return userData?.lmsmonthly === true || userData?.lmsannual === true;
  }, [userData]);

  const hasOutreachAccess = useMemo(() => {
    if (!userData?.outreachAnnual && !userData?.outreachMonthly && !hasLmsAccess) return true;
    return userData?.outreachAnnual === true || userData?.outreachMonthly === true;
  }, [userData]);

  const handleUserNameMenuOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setUserNameMenuElement(event.currentTarget);
  };

  const handleMenuClose = () => {
    setUserNameMenuElement(null);
  };

  const handleLogout = (event) => {
    // setTenantHash();
    handleMenuClose();
    dispatch(logout(event));
  };

  const isGetUserOnTrial = (user) => {
    if (!user?.tenants?.length || !user.tenants[0].subscription) {
      return false;
    }
    const subscriptionData = user.tenants[0].subscription;
    const hasActiveStatus = Object.values(subscriptionData).filter(
      (item) =>
        item &&
        Object.keys(item).length > 0 &&
        item?.status === 'active' &&
        !trialSubscriptionPlansPriceId.includes(item?.item_price_id || item?.entity_id),
    );
    return hasActiveStatus?.length > 0;
  };

  const showUpgradePlan = useMemo(() => isGetUserOnTrial(userData), [userData]);

  return (
    <Stack position={'fixed'} top={'0'} bottom={'0'} left={'0'} right={'0'} zIndex={10000}>
      <Stack color={'white'} width={'100vw'} height={'100vh'} bgcolor={'#021424'}>
        <Box
          sx={{
            padding: '0px 48px',
            height: '44px',
            backgroundColor: '#060A0D',
          }}
          display={'flex'}
          gap={'24px'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <img src={images.app.logoWhite} height={'24px'} width={'120px'} />
          <Box
            onClick={handleUserNameMenuOpen}
            sx={{ position: 'relative', zIndex: 1000 }} // Adding z-index here
          >
            <Box
              display="flex"
              alignItems="center"
              gap="8px"
              sx={{
                cursor: 'pointer',
                border: '1px solid #1A2633',
                boxShadow: !Boolean(userNameMenuElement) ? 'none' : '0px 4px 4px 0px #26394D',
                padding: '4px 10px',
                borderRadius: '999px',
              }}
            >
              <img src={images.icons.whiteAppIcon} alt="app icon" />
              <Avatar
                sx={{
                  width: '20px',
                  height: '20px',
                  fontSize: '16px',
                  backgroundColor: '#AB47BC',
                  textTransform: 'capitalize',
                }}
              >
                {name.charAt(0)}
              </Avatar>
            </Box>
          </Box>
          <AppMenu
            handleMenuClose={handleMenuClose}
            userNameMenuElement={userNameMenuElement}
            userNameId={userNameId}
            hasLmsAccess={hasLmsAccess}
            hasOutreachAccess={hasOutreachAccess}
            showUpgradePlan={showUpgradePlan}
            user={userData}
            handleLogout={handleLogout}
            isLandingPage={true}
            setIsModalOpen={setIsModalOpen}
            {...props}
          />
        </Box>
        <UpgradeSubscriptionModal setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />

        <Stack justifyContent={'center'} alignItems={'center'} padding={'80px 48px'}>
          <Stack width={'100%'} maxWidth={'900px'} justifyContent={'center'}>
            <Stack justifyContent={'center'} gap={'64px'}>
              <Stack gap={'16px'} justifyContent={'center'} alignItems={'center'}>
                <Typography fontSize={'45px'} fontWeight={200}>
                  Good Morning, {userData?.fname}!
                </Typography>
                <Typography fontSize={'22px'} fontWeight={300} sx={{ color: '#CCCCCC' }}>
                  What would you like to do today?
                </Typography>
              </Stack>
              <Stack gap={'32px'} justifyContent={'center'} alignItems={'center'} direction={'row'}>
                {hasLmsAccess && (
                  <Stack
                    gap={'24px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    width={'100%'}
                    maxWidth={'176px'}
                    onClick={() => {
                      window.location.replace(process.env.REACT_APP_LMS_URL);
                    }}
                  >
                    <img
                      height={'64px'}
                      width={'64px'}
                      src={images.loginDashboard.learning}
                      style={{ borderRadius: '10px', cursor: 'pointer' }}
                    />
                    <Typography
                      fontSize={'26px'}
                      fontWeight={200}
                      lineHeight={'31.2px'}
                      sx={{ cursor: 'pointer' }}
                    >
                      Learning
                    </Typography>
                  </Stack>
                )}

                {hasOutreachAccess && (
                  <Stack
                    gap={'24px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    width={'100%'}
                    maxWidth={'176px'}
                    onClick={() => {
                      history.push('/outreachvideolibrary');
                      // history.push('/onboarding');
                      dispatch(showWelcomeModal(false));
                    }}
                  >
                    <img
                      height={'64px'}
                      width={'64px'}
                      src={images.loginDashboard.outreach}
                      style={{ borderRadius: '10px', cursor: 'pointer' }}
                    />
                    <Typography
                      fontSize={'26px'}
                      fontWeight={200}
                      lineHeight={'31.2px'}
                      sx={{ cursor: 'pointer' }}
                    >
                      Outreach
                    </Typography>
                  </Stack>
                )}

                {/*  <Stack*/}
                {/*    gap={'24px'}*/}
                {/*    justifyContent={'center'}*/}
                {/*    width={'100%'}*/}
                {/*    maxWidth={'176px'}*/}
                {/*    alignItems={'center'}*/}
                {/*  >*/}
                {/*    <img*/}
                {/*      height={'64px'}*/}
                {/*      width={'64px'}*/}
                {/*      src={images.loginDashboard.trillion}*/}
                {/*      style={{ borderRadius: '10px' }}*/}
                {/*    />*/}
                {/*    <Typography fontSize={'26px'} fontWeight={200} lineHeight={'31.2px'}>*/}
                {/*      Trillion*/}
                {/*    </Typography>*/}
                {/*  </Stack>*/}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default LandingPageView;
